import { RefreshCw, X } from "lucide-react";
import { IconButton } from "@dfws/ui";
import s from "./MailToolbar.module.css";

export interface MailToolbarProps {
  title: string;
  shown: number;
  total: number;
  checkedCount: number;
  onClearSelection: () => void;
  onRefresh: () => void;
  refreshing: boolean;
}

export function MailToolbar({ title, shown, total, checkedCount, onClearSelection, onRefresh, refreshing }: MailToolbarProps) {
  if (checkedCount > 0) {
    return (
      <div className={s.toolbar} data-selection role="toolbar" aria-label="Selection">
        <IconButton label="Clear selection" icon={<X />} size="sm" onClick={onClearSelection} />
        <span className={s.title}>{checkedCount} selected</span>
        <span className={s.hint}>Bulk actions arrive in Phase 4</span>
      </div>
    );
  }
  return (
    <div className={s.toolbar} role="toolbar" aria-label="List actions">
      <h1 className={s.title}>{title}</h1>
      <span className={s.spacer} />
      <span className={s.range}>{total > 0 ? `${Math.min(shown, total).toLocaleString("en-GB")} of ${total.toLocaleString("en-GB")}` : ""}</span>
      <IconButton label="Refresh" icon={<RefreshCw className={refreshing ? s.spin : undefined} />} size="sm" onClick={onRefresh} />
    </div>
  );
}
